<script setup lang="ts">
const { t, locale } = useI18n()
const { collection } = useBlog()
const crumbs = usePageMeta('blog')

const { data: posts } = await useAsyncData(`blog-${locale.value}`, () =>
  queryCollection(collection.value).select('title', 'description', 'path', 'date', 'updated', 'image', 'imageAlt', 'tags').all().then(byLastChange),
)

// Topic filter: purely client-side over the prerendered list; without JS every post is listed.
const active = ref<string | null>(null)
const tags = computed(() => [...new Set((posts.value ?? []).flatMap(p => p.tags))].sort())
const visible = computed(() => (posts.value ?? []).filter(p => !active.value || p.tags.includes(active.value)))

useSchemaOrg([
  {
    '@type': 'Blog',
    'name': `DEGOYA.digital ${t('blog.title')}`,
    'publisher': { '@id': useSchemaIds().identity },
  },
])
</script>

<template>
  <div>
    <PageHeader
      :title="t('blog.title')"
      :lead="t('blog.lead')"
      :crumbs="crumbs"
    />
    <div class="container-site section pt-6">
      <div
        v-if="tags.length"
        role="group"
        :aria-label="t('blog.filter')"
        class="mb-10 flex flex-wrap gap-2"
      >
        <button
          v-for="tag in [null, ...tags]"
          :key="tag ?? 'all'"
          type="button"
          class="min-h-11 border-2 px-4 text-sm font-semibold transition-colors"
          :class="active === tag ? 'border-ink bg-ink text-white' : 'border-muted text-ink hover:border-ink'"
          :aria-pressed="active === tag"
          @click="active = tag"
        >
          {{ tag ?? t('blog.allTags') }}
        </button>
      </div>
      <ul class="grid grid-lines sm:grid-cols-2 lg:grid-cols-3">
        <li
          v-for="post in visible"
          :key="post.path"
          class="flex"
        >
          <PostCard
            :post="post"
            heading-level="h2"
            class="w-full"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
